import { Expose, Type } from "class-transformer";
import { IsArray, IsDefined, IsInt, IsOptional, IsUUID } from "class-validator";
import { v4 as uuid } from "uuid";

import { GField, GObjectType } from "../graphql";
import { CDBaseEntity, CDColumn, CDEntity, CDObjectIdColumn } from "../orm";
import type { RideStop } from "../RideStop";
import { TransformToDate } from "../transformers/transformToDate";

import { RideNote } from "./RideNote";

@GObjectType("Ride")
@CDEntity("rides")
export class Ride extends CDBaseEntity {
    @GField()
    @CDObjectIdColumn()
    @IsUUID("4")
    @Expose()
    public _id: string = uuid();

    @CDColumn()
    @IsArray()
    @IsDefined()
    @Expose()
    public orderIds: Array<string> = [];

    @CDColumn()
    @IsArray()
    @IsDefined()
    @Expose()
    public lockedOrderIds: Array<string> = [];

    @CDColumn()
    @IsDefined()
    @IsUUID("4")
    public originLocationId: string;

    @CDColumn()
    @IsDefined()
    @IsUUID("4")
    public destinationLocationId: string;

    @CDColumn()
    @IsDefined()
    @IsUUID("4")
    public routeId: string;

    @CDColumn()
    @IsDefined()
    public isOtherDirection: boolean;

    @CDColumn()
    @IsDefined()
    @IsArray()
    public stops: RideStop[] = [];

    @CDColumn()
    @IsDefined()
    @Expose()
    @TransformToDate
    public departureAt: Date; // in fake UTC - hour corresponds to local departure time

    @CDColumn()
    @IsDefined()
    @Expose()
    @TransformToDate
    public departureAtLatest: Date; // in fake UTC - hour corresponds to local departure time

    @CDColumn()
    @IsInt()
    @Expose()
    public availableSeats: number;

    @CDColumn()
    @IsInt()
    @Expose()
    public totalSeats: number;

    @CDColumn()
    @IsOptional()
    @IsInt()
    @Expose()
    public price?: number;

    @CDColumn()
    @IsOptional()
    @IsInt()
    @Expose()
    public subsidyId?: string;

    @CDColumn()
    @IsDefined()
    @IsArray()
    @Type(() => RideNote)
    public notes: RideNote[] = [];
}
